import Modal from "@mui/material/Modal";
import { useDispatch } from "react-redux";
import classes from "./ConfirmNeemPaymentModal.module.css";
import CollectedMaintenanceCard from "../../pages/user/Bills/CollectedMaintenanceCard";
import { formatMobileNumber } from "../../helpers";
import MyButton from "../../components/MyButton";
import { setOnlinePaymentReceived } from "../../store/onlinePaymentSlice";
import HeaderAction from "../../components/HeaderAction";
const NeemConfirmationModal = ({
    show,
    setShow,
    onBack,
    data,
    title = "Wallet Activation",
    onPrint,
    onSuccess,
}) => {
    const dispatch = useDispatch();


    console.log("SData", data)
    // Close handler for Modal
    const handleClose = (event, reason) => {
        // Prevent modal from closing on backdrop click or ESC if desired
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;

        dispatch(setOnlinePaymentReceived(false));
        setShow(false);
        onBack?.();
        onSuccess?.()
    };

    // Common handler for buttons
    const handlePrintClick = () => {
        dispatch(setOnlinePaymentReceived(false));
        setShow(false);
        onBack?.();
        onPrint()
    };


    const handleOkay = () => {
        dispatch(setOnlinePaymentReceived(false));
        setShow(false);
        onBack?.();
        onSuccess?.()


    }
    return (
        <>
            <style>{`
        .modal-sm {
          --bs-modal-width: 550px;
        }
        .modal-content {
          border-radius: 16px;
        }
      `}</style>

            <Modal
                open={show}
                onClose={handleClose}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <div className={`${classes.container} ${classes.customModal}`}>

                    <HeaderAction onClick={() => {
                        handleOkay()
                    }} title={"Payment Receipt"}
                        className={classes.heading}
                    />
                    {/* Flat Info */}
                    <div className={classes.flatInfo}>
                        <div className={classes.content}>
                            <p className={classes.flatNo}>{`${data?.ammenityName}: ${data?.prefix}-${data?.unitName}`}</p>
                            <h3 className={classes.flatName}>{data?.userInfo?.[0]?.name}</h3>
                            <h3 className={classes.flatPhoNo}>
                                {formatMobileNumber(data?.userInfo?.[0]?.cellNo)}
                            </h3>
                        </div>
                    </div>

                    {/* Maintenance Card */}
                    <CollectedMaintenanceCard data={data} />

                    {/* Buttons */}
                    <div className={classes.btnWrapper}>
                        <MyButton
                            btnText="Print"
                            className={classes.receivedBtnStyles}
                            handler={handlePrintClick}
                        />
                        <MyButton
                            btnText="Okay"
                            className={classes.receivedBtnStyles}
                            handler={handleOkay}
                        />
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default NeemConfirmationModal;
